import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { DadosArquivisticosModel } from './dados-arquivisticos.model';

@Injectable()
export class DadosArquivisticosService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  salvarDadosArquivisticos(dados): Observable<DadosArquivisticosModel> {
    return this.httpClient.post<DadosArquivisticosModel>(this.apiURL + '/dados-arquivisticos', dados, this.httpOptions);
  }

  listaDadosArquivisticos(clienteId, tipoId): Observable<DadosArquivisticosModel[]> {
    return this.httpClient.get<DadosArquivisticosModel[]>(this.apiURL + `/dados-arquivisticos/${tipoId}/${clienteId}`, this.httpOptions);
  }

  listarNodeDicionario(id): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + `/node-dicionario/${id}`, this.httpOptions);
  }

  listarDadosArquivisticosEspecificos(clienteId, propId, tipoId): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + `/dados-arquivisticos/especifico/${clienteId}/${propId}/${tipoId}`, this.httpOptions);
  }

  excluirDadoArquivistico(id) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));
    return this.httpClient.delete(this.apiURL + `/dados-arquivisticos/${id}`,  { headers, responseType: 'text' });
  }

  editarDadoArquivistico(dados): Observable<DadosArquivisticosModel> {
    return this.httpClient.put<DadosArquivisticosModel>(this.apiURL + '/dados-arquivisticos/editar', dados, this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/dados-arquivisticos/dados-arquivisticos.service.ts